import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { fileTypes } from '../../flows/transactions/components/TransactionReceipt';

const {
  CONTROLLERS: {
    RECEIPT: { VERSION, BASE },
  },
} = USER;

export const useDownloadReceiptMutation = ({
  customerId,
  transactionId,
  isExternal,
  accountExternalId,
  externalAccountId,
}: {
  customerId: string;
  transactionId: string;
  isExternal?: boolean;
  accountExternalId?: string;
  externalAccountId?: string;
}) =>
  useMutation(async () => {
    try {
      const url = isExternal
        ? `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/externalAccount/${externalAccountId}/transaction/${transactionId}/receipt`
        : `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${transactionId}/receipt`;
      const { data, headers } = await httpService({
        url,
        method: 'get',
        responseType: 'blob',
      });

      return {
        url: URL.createObjectURL(data),
        type: headers['content-type'].includes('pdf') ? fileTypes.PDF : fileTypes.IMAGE,
      };
    } catch (e) {
      return undefined;
    }
  });
